import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "confirmationModal", "companyName",
    "preventionModal", "companyNamePrevention", "invoicesList", "totalCount", "invoicesLink"
  ]
  static values = {
    companyId: String,
    companyName: String
  }

  connect() {
    // Populate company names in modals
    if (this.hasCompanyNameTarget) {
      this.companyNameTarget.textContent = this.companyNameValue
    }
    if (this.hasCompanyNamePreventionTarget) {
      this.companyNamePreventionTarget.textContent = this.companyNameValue
    }
  }

  async checkDeletion(event) {
    event.preventDefault()
    
    try {
      const response = await fetch(`/companies/${this.companyIdValue}/check_delete_safety`, {
        method: 'GET',
        headers: {
          'X-CSRF-Token': this.getCSRFToken(),
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })

      const data = await response.json()

      if (data.can_delete) {
        this.showConfirmationModal()
      } else {
        this.showPreventionModal(data.invoices, data.total_count)
      }
    } catch (error) {
      console.error('Failed to check deletion safety:', error)
      alert('Įvyko klaida tikrinant ar galima ištrinti įmonę')
    }
  }

  async confirmDeletion(event) {
    event.preventDefault()

    try {
      const response = await fetch(`/companies/${this.companyIdValue}`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': this.getCSRFToken(),
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })

      const data = await response.json()

      if (data.success) {
        // Use document.referrer to go back to the filtered list
        const backUrl = document.referrer && document.referrer.includes('/companies')
          ? document.referrer
          : '/companies'
        window.location.href = backUrl
      } else {
        this.closeConfirmation()
        alert(data.message || 'Įvyko klaida trinant įmonę')
      }
    } catch (error) {
      console.error('Failed to delete company:', error)
      this.closeConfirmation()
      alert('Įvyko klaida trinant įmonę')
    }
  }

  showConfirmationModal() {
    this.confirmationModalTarget.showModal()
  }

  closeConfirmation() {
    this.confirmationModalTarget.close()
  }

  closeConfirmationOnBackdrop(event) {
    if (event.target === this.confirmationModalTarget) this.closeConfirmation()
  }

  showPreventionModal(invoices, totalCount) {
    // Populate total count
    if (this.hasTotalCountTarget) {
      this.totalCountTarget.textContent = totalCount
    }

    // Set the invoices link URL with company filter
    if (this.hasInvoicesLinkTarget) {
      const invoicesUrl = `/invoices?company_id=${this.companyIdValue}`
      this.invoicesLinkTarget.href = invoicesUrl
    }

    // Populate invoices list with improved styling
    this.invoicesListTarget.innerHTML = invoices.map(invoice => `
      <div class="flex justify-between items-center p-2 bg-gray-50 rounded border border-gray-100">
        <div class="flex-1">
          <div class="font-medium text-gray-900">${invoice.number}</div>
          <div class="text-xs text-gray-500">${invoice.date}</div>
        </div>
        <span class="text-xs font-medium px-2 py-1 rounded-full ${
          invoice.role === 'Pardavėjas' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
        }">${invoice.role}</span>
      </div>
    `).join('')

    if (totalCount > invoices.length) {
      this.invoicesListTarget.innerHTML += `
        <div class="text-center py-3 text-sm text-gray-500 italic border-t border-gray-200 mt-2 pt-2">
          ... ir dar ${totalCount - invoices.length} sąskaita(-os)
        </div>
      `
    }

    this.preventionModalTarget.showModal()
  }

  closePrevention() {
    this.preventionModalTarget.close()
  }

  closePreventionOnBackdrop(event) {
    if (event.target === this.preventionModalTarget) this.closePrevention()
  }

  getCSRFToken() {
    const token = document.querySelector('meta[name="csrf-token"]')
    return token ? token.getAttribute('content') : ''
  }
}
